import styled from 'styled-components';

const BgShadowContainer = styled.div`
	position: fixed;
	width: 100%;
	height: 100%;
	opacity: 0.98;
`;

export { BgShadowContainer };
